export const ActionKeys = {
  RESET_IS_FETCHED: "RESET_IS_FETCHED",
  RESET_ACTIVE_CHAPTER_BUDGET: "RESET_ACTIVE_CHAPTER_BUDGET",
  REQUEST_HELP_TEXT: "REQUEST_HELP_TEXT",
  RECEIVE_HELP_TEXT: "RECEIVE_HELP_TEXT",
  UPDATE_HELP_TEXT: "UPDATE_HELP_TEXT",
  REQUEST_FISCAL_YEAR: "REQUEST_FISCAL_YEAR",
  RECEIVE_FISCAL_YEAR: "RECEIVE_FISCAL_YEAR",
  UPDATE_FISCAL_YEAR: "UPDATE_FISCAL_YEAR",
  RECEIVE_MAILING_ADDRESS: "RECEIVE_MAILING_ADDRESS",
  REQUEST_MAILING_ADDRESS: "REQUEST_MAILING_ADDRESS",
  UPDATE_MAILING_ADDRESS: "UPDATE_MAILING_ADDRESS",
  REQUEST_CHAPTER_RANGES: "REQUEST_CHAPTER_RANGES",
  RECEIVE_CHAPTER_RANGES: "RECEIVE_CHAPTER_RANGES",
  UPDATE_CHAPTER_RANGE: "UPDATE_CHAPTER_RANGE",
  UPDATE_CHAPTER_RANGES: "UPDATE_CHAPTER_RANGES",
  REQUEST_MEMBER_COUNTS: "REQUEST_MEMBER_COUNTS",
  RECEIVE_MEMBER_COUNTS: "RECEIVE_MEMBER_COUNTS",
  CREATE_MEMBER_COUNT: "CREATE_MEMBER_COUNT",
  UPDATE_MEMBER_COUNT: "UPDATE_MEMBER_COUNT",
  REQUEST_CHAPTER_LIST: "REQUEST_CHAPTER_LIST",
  RECEIVE_CHAPTER_LIST: "RECEIVE_CHAPTER_LIST",
  REQUEST_CHAPTER: "REQUEST_CHAPTER",
  RECEIVE_CHAPTER: "RECEIVE_CHAPTER",
  REQUEST_CHAPTER_BUDGETS: "REQUEST_CHAPTER_BUDGETS",
  RECEIVE_CHAPTER_BUDGETS: "RECEIVE_CHAPTER_BUDGETS",
  REQUEST_CHAPTER_BUDGET: "REQUEST_CHAPTER_BUDGET",
  RECEIVE_CHAPTER_BUDGET: "RECEIVE_CHAPTER_BUDGET",
  CREATE_CHAPTER_BUDGET_STARTED: "CREATE_CHAPTER_BUDGET_STARTED",
  CREATE_CHAPTER_BUDGET_FINISHED: "CREATE_CHAPTER_BUDGET_FINISHED",
  UPDATE_CHAPTER_BUDGET_STARTED: "UPDATE_CHAPTER_BUDGET_STARTED",
  UPDATE_CHAPTER_BUDGET_FINISHED: "UPDATE_CHAPTER_BUDGET_FINISHED",
  UPDATE_CHAPTER_BUDGET_FILE_STARTED: "UPDATE_CHAPTER_BUDGET_FILE_STARTED",
  UPDATE_CHAPTER_BUDGET_FILE_FINISHED: "UPDATE_CHAPTER_BUDGET_FILE_FINISHED",
  DOWNLOAD_CHAPTER_BUDGET_FILE_STARTED: "DOWNLOAD_CHAPTER_BUDGET_FILE_STARTED",
  DOWNLOAD_CHAPTER_BUDGET_FILE_FINISHED:
    "DOWNLOAD_CHAPTER_BUDGET_FILE_FINISHED",
  REQUEST_CHAPTER_FINANCIALS: "REQUEST_CHAPTER_FINANCIALS",
  RECEIVE_CHAPTER_FINANCIALS: "RECEIVE_CHAPTER_FINANCIALS",
  REQUEST_CHAPTER_FINANCIALS_DEFAULTS: "REQUEST_CHAPTER_FINANCIALS_DEFAULTS",
  RECEIVE_CHAPTER_FINANCIALS_DEFAULTS: "RECEIVE_CHAPTER_FINANCIALS_DEFAULTS",
  REQUEST_CHAPTER_FINANCIAL: "REQUEST_CHAPTER_FINANCIAL",
  RECEIVE_CHAPTER_FINANCIAL: "RECEIVE_CHAPTER_FINANCIAL",
  REQUEST_REPORT_ITEM_TYPES: "REQUEST_REPORT_ITEM_TYPES",
  RECEIVE_REPORT_ITEM_TYPES: "RECEIVE_REPORT_ITEM_TYPES",
  REQUEST_REPORT_ITEM_SUB_TYPES: "REQUEST_REPORT_ITEM_SUB_TYPES",
  RECEIVE_REPORT_ITEM_SUB_TYPES: "RECEIVE_REPORT_ITEM_SUB_TYPES",
  UPDATE_REPORT_ADMIN_NOTES_STARTED: "UPDATE_REPORT_ADMIN_NOTES_STARTED",
  UPDATE_REPORT_ADMIN_NOTES_FINISHED: "UPDATE_REPORT_ADMIN_NOTES_FINISHED",
  CREATE_REPORT_ADMIN_NOTES_STARTED: "CREATE_REPORT_ADMIN_NOTES_STARTED",
  CREATE_REPORT_ADMIN_NOTES_FINISHED: "CREATE_REPORT_ADMIN_NOTES_FINISHED",
  CREATE_REPORT_ITEM_STARTED: "CREATE_REPORT_ITEM_STARTED",
  CREATE_REPORT_ITEM_FINISHED: "CREATE_REPORT_ITEM_FINISHED",
  UPDATE_REPORT_ITEM_STARTED: "UPDATE_REPORT_ITEM_STARTED",
  UPDATE_REPORT_ITEM_FINISHED: "UPDATE_REPORT_ITEM_FINISHED",
  REMOVE_REPORT_ITEM_STARTED: "REMOVE_REPORT_ITEM_STARTED",
  REMOVE_REPORT_ITEM_FINISHED: "REMOVE_REPORT_ITEM_FINISHED",
  UPDATE_REPORT_ITEMS_STARTED: "UPDATE_REPORT_ITEMS_STARTED",
  UPDATE_REPORT_ITEMS_FINISHED: "UPDATE_REPORT_ITEMS_FINISHED",
  INITIAL_REPORT_ITEMS_STARTED: "INITIAL_REPORT_ITEMS_STARTED",
  INITIAL_REPORT_ITEMS_FINISHED: "INITIAL_REPORT_ITEMS_FINISHED",
  UPDATE_REPORT_W2_STARTED: "UPDATE_REPORT_W2_STARTED",
  UPDATE_REPORT_W2_FINISHED: "UPDATE_REPORT_W2_FINISHED",
  UPDATE_REPORT_VOTING_COUNT_STARTED: "UPDATE_REPORT_VOTING_COUNT_STARTED",
  UPDATE_REPORT_VOTING_COUNT_FINISHED: "UPDATE_REPORT_VOTING_COUNT_FINISHED",
  CREATE_FINANCIAL_ACCOUNT_STARTED: "CREATE_FINANCIAL_ACCOUNT_STARTED",
  CREATE_FINANCIAL_ACCOUNT_FINISHED: "CREATE_FINANCIAL_ACCOUNT_FINISHED",
  UPDATE_FINANCIAL_ACCOUNT_STARTED: "UPDATE_FINANCIAL_ACCOUNT_STARTED",
  UPDATE_FINANCIAL_ACCOUNT_FINISHED: "UPDATE_FINANCIAL_ACCOUNT_FINISHED",
  REMOVE_FINANCIAL_ACCOUNT_STARTED: "REMOVE_FINANCIAL_ACCOUNT_STARTED",
  REMOVE_FINANCIAL_ACCOUNT_FINISHED: "REMOVE_FINANCIAL_ACCOUNT_FINISHED",
  REQUEST_CHAPTER_FINANCIAL_BY_YEAR: "REQUEST_CHAPTER_FINANCIAL_BY_YEAR",
  RECEIVE_CHAPTER_FINANCIAL_BY_YEAR: "RECEIVE_CHAPTER_FINANCIAL_BY_YEAR",
  SUBMIT_CHAPTER_FINANCIAL_STARTED: "SUBMIT_CHAPTER_FINANCIAL_STARTED",
  SUBMIT_CHAPTER_FINANCIAL_FINISHED: "SUBMIT_CHAPTER_FINANCIAL_FINISHED",
  ACCEPT_CHAPTER_FINANCIAL_STARTED: "ACCEPT_CHAPTER_FINANCIAL_STARTED",
  ACCEPT_CHAPTER_FINANCIAL_FINISHED: "ACCEPT_CHAPTER_FINANCIAL_FINISHED",
  REJECT_CHAPTER_FINANCIAL_STARTED: "REJECT_CHAPTER_FINANCIAL_STARTED",
  REJECT_CHAPTER_FINANCIAL_FINISHED: "REJECT_CHAPTER_FINANCIAL_FINISHED",
  REQUEST_CHAPTER_SUMMARY_REPORT: "REQUEST_CHAPTER_SUMMARY_REPORT",
  RECEIVE_CHAPTER_SUMMARY_REPORT: "RECEIVE_CHAPTER_SUMMARY_REPORT",
  REQUEST_GLOBAL_ANALYSIS_REPORTS: "REQUEST_GLOBAL_ANALYSIS_REPORTS",
  RECEIVE_GLOBAL_ANALYSIS_REPORTS: "RECEIVE_GLOBAL_ANALYSIS_REPORTS",
  REQUEST_CHAPTER_ANALYSIS_REPORTS: "REQUEST_CHAPTER_ANALYSIS_REPORTS",
  RECEIVE_CHAPTER_ANALYSIS_REPORTS: "RECEIVE_CHAPTER_ANALYSIS_REPORTS",
  REQUEST_CHAPTER_FINANCIAL_REPORT: "REQUEST_CHAPTER_FINANCIAL_REPORT",
  RECEIVE_CHAPTER_FINANCIAL_REPORT: "RECEIVE_CHAPTER_FINANCIAL_REPORT",
  REQUEST_CHAPTER_MEMBER_COUNT_TEMPLATE:
    "REQUEST_CHAPTER_MEMBER_COUNT_TEMPLATE",
  RECEIVE_CHAPTER_MEMBER_COUNT_TEMPLATE:
    "RECEIVE_CHAPTER_MEMBER_COUNT_TEMPLATE",
  UPLOAD_MEMBER_COUNTS: "UPLOAD_MEMBER_COUNTS",
  UPLOADED_MEMBER_COUNTS: "UPLOADED_MEMBER_COUNTS"
};
